<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import {
	SelectIcon,
	SelectTrigger,
	type SelectTriggerProps,
	useForwardProps
} from 'radix-vue';
import KeyboardArrowDown from '~icons/material-symbols-light/keyboard-arrow-down';
import { cn } from '@/utils';

const props = defineProps<
	SelectTriggerProps & {
		class?: HTMLAttributes['class'];
		arrowClass?: HTMLAttributes['class'];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, arrowClass: _arrowClass, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectTrigger
		v-bind="forwardedProps"
		:class="
			cn(
				'flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-start text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate',
				props.class
			)
		"
	>
		<slot></slot>
		<SelectIcon as-child>
			<KeyboardArrowDown
				:class="cn('h-5 w-5 shrink-0 text-beige', arrowClass)"
			/>
		</SelectIcon>
	</SelectTrigger>
</template>
